export default "__VITE_ASSET__3MZW4swp__"